const STORAGE_KEY = 'astrec.global-audio.volume';

export type GlobalAudioVolumePrefs = {
  volume: number;
  muted: boolean;
};

const DEFAULT_PREFS: GlobalAudioVolumePrefs = { volume: 1, muted: false };

function clamp01(n: number): number {
  if (!Number.isFinite(n)) return 0;
  return Math.min(1, Math.max(0, n));
}

export function loadGlobalAudioVolumePrefs(): GlobalAudioVolumePrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw) as Partial<GlobalAudioVolumePrefs>;
    return {
      volume: clamp01(typeof parsed.volume === 'number' ? parsed.volume : 1),
      muted: parsed.muted === true,
    };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function saveGlobalAudioVolumePrefs(prefs: GlobalAudioVolumePrefs): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        volume: clamp01(prefs.volume),
        muted: prefs.muted === true,
      }),
    );
  } catch {
    /* ignore quota / private mode */
  }
}

/** Effective HTMLAudioElement.volume from user prefs. */
export function effectiveAudioVolume(prefs: Pick<GlobalAudioVolumePrefs, 'volume' | 'muted'>): number {
  if (prefs.muted) return 0;
  return clamp01(prefs.volume);
}
